"use client";
import SectionPage from "@/components/common/section-page";

import { useNavigate } from "react-router-dom";
import {PaveScaleCard} from "@/components/common/pave-scale-card";
import EspaceProTitleCard from "@/components/common/espace-pro-title-card";

export default function Home() {
  const navigate = useNavigate();

  return (
          <div className={"flex flex-col gap-6 pb-6 mb-8"}>

            <EspaceProTitleCard title={"Forums & Séminaires"}
                                middleBreadcrumbs={[{title: "Promotion", link: "/espace-pro/promotion"}]}
                                description={"Côte d’Ivoire Tourisme Partenaire de réussite de l’industrie touristique."} />

              <SectionPage sectionType="sm">
                  <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-4 mt-6 mb-6">
                      <PaveScaleCard title={<></>} buttonLabel={"Télécharger"} className={"h-[400px] text-center"} image={"/images/espace-pro/promotion/forums-seminaires/1.jpg"} link="/pdf-viewer/FORUM-2022-Synthese-provisoire-projet-7-06042023.pdf" titleClassName={"font-playfair-display italic font-bold"} />
                      <PaveScaleCard title={<></>} buttonLabel={"Télécharger"} className={"h-[400px] text-center"} image={"/images/espace-pro/promotion/forums-seminaires/2.jpg"} link="/pdf-viewer/FORUM-2022-Synthese-provisoire-projet-7-06042023.pdf" titleClassName={"font-playfair-display italic font-bold"} />
                      <PaveScaleCard title={<></>} buttonLabel={"Télécharger"} className={"h-[400px] text-center"}
                                     link="/pdf-viewer/Dossier-de-Presse-Top-Resa-2023-ok-bonne-version.pdf"
                                     image={"/images/actualites/foires-et-salons/dossier-presse.png"}
                                     titleClassName={"font-playfair-display-italic text-xl"} />
                  </div>
              </SectionPage>

        </div>
  );
}
